import { Dispatch, authResponses, commonErrorResponses } from "redux/commonTypes";
import authApi from "./authApi";
import { actionTypes, AuthActionsType } from "./authTypes";
import profileActions from "redux/ducks/profile/profileActions";
import { genderEnum, genderEnumFromApi } from "../profile/profileTypes";

// Кэш локализованных городов по стране из гео-эндпоинта (на время сессии).
let geoCitiesByCountry: Record<string, Array<{ id: any; name: string }>> = {};

type signInProps = {
  phone: string;
  countryCode: string;
  oneTimePassword: string;
  pinCode?: string;
};

type signUpProps = {
  phone: string;
  countryCode: string;
  oneTimePassword: string;
  name: string;
  sex: string;
  interestedGender: string;
  birthday: string;
  cityId: number;
};

type passwordErrProps = {
  timeLeftForUnblock?: number;
  attemptsLeft?: number;
  errStatus: boolean;
};

type dataType = {
  name: string;
  id: number;
};

const Actions = {
  setIsAuth: (bool: boolean): AuthActionsType => ({
    type: actionTypes.SET_IS_AUTH,
    payload: bool,
  }),
  setRefreshing: (bool: boolean) => ({
    type: actionTypes.SET_REFRESHING,
    payload: bool,
  }),
  setOffline: (bool: boolean) => ({
    type: actionTypes.OFFLINE,
    payload: bool,
  }),
  refresh: (from?: string) => ({
    type: actionTypes.REFRESH,
    payload: from
  }),
  firstRefresh: (status: boolean) => ({
    type: actionTypes.FIRST_REFRESH,
    payload: status
  }),
  setTokens: (refreshToken: string | null, accessToken: string | null) => ({
    type: actionTypes.SET_TOKENS,
    payload: { refreshToken, accessToken },
  }),
  setIsTokenValid: (bool: boolean) => ({
    type: actionTypes.SET_TOKEN_IS_VALID,
    payload: bool,
  }),
  setPhone: (phone: string | null) => ({
    type: actionTypes.SET_PHONE,
    payload: phone,
  }),
  setCode: (code: string): AuthActionsType => ({
    type: actionTypes.SET_COUNTRY_CODE,
    payload: code,
  }),
  setPassword: (oneTimePassword?: string | null) => ({
    type: actionTypes.SET_PASSWORD,
    payload: oneTimePassword,
  }),
  setSignUp: (isSigningUp: boolean): AuthActionsType => ({
    type: actionTypes.SET_SIGNING_UP,
    payload: isSigningUp,
  }),
  setPasswordErr: ({
    timeLeftForUnblock,
    attemptsLeft,
    errStatus,
  }: passwordErrProps): AuthActionsType => ({
    type: actionTypes.SET_PASSWORD_ERR,
    payload: { errStatus, attemptsLeft, timeLeftForUnblock },
  }),
  setSystemBan: (status: boolean, reason: number): AuthActionsType => ({
    type: actionTypes.SET_SYSTEM_BAN,
    payload: { status, reason },
  }),
  setProfileDeleted: (deletedStatus: boolean): AuthActionsType => ({
    type: actionTypes.SET_PROFILE_DELETED,
    payload: deletedStatus,
  }),
  setIsHideAuthHeader: (isHide: boolean) => ({
    type: actionTypes.SET_IS_HIDE_AUTH_HEADER,
    payload: isHide,
  }),
  setPhoneErr: (errStatus: boolean): AuthActionsType => ({
    type: actionTypes.SET_PHONE_ERR,
    payload: errStatus,
  }),
  setIsPinCodeNeed: (isNeed: boolean): AuthActionsType => ({
    type: actionTypes.SET_IS_PINCODE_NEED,
    payload: isNeed,
  }),
  setPinCodeErr: (err: boolean): AuthActionsType => ({
    type: actionTypes.SET_PINCODE_ERR,
    payload: err,
  }),
  setIsFilling: (status: boolean): AuthActionsType => ({
    type: actionTypes.SET_IS_FILLING,
    payload: status,
  }),
  setIsVerified: (status: boolean): AuthActionsType => ({
    type: actionTypes.SET_IS_VERIFIED,
    payload: status,
  }),
  resetAll: () => ({
    type: actionTypes.RESET_ALL_AUTH,
  }),
  setIsWebcam: (status: boolean): AuthActionsType => ({
    type: actionTypes.SET_WEBCAM,
    payload: status,
  }),
  setCountriesList: (list: Array<dataType>) => ({
    type: actionTypes.SET_COUNTRIES_LIST,
    payload: list,
  }),
  setCitiesList: (list: Array<dataType>) => ({
    type: actionTypes.SET_CITIES_LIST,
    payload: list,
  }),
  setSocket: (ticket: string) => ({
    type: actionTypes.SET_SOCKET,
    payload: ticket,
  }),
  setIsTempBanned: (status: boolean, timeLeft?: string) => ({
    type: actionTypes.SET_IS_TEMP_BLOCKED,
    payload: { status, timeLeft }
  }),
  sendCode: (phone: string, countryCode: string) => (
    dispatch: Dispatch
  ): void => {
    dispatch(Actions.setPhone(phone));
    authApi.sendCode(phone, countryCode).catch((err) => {
      if (err.response?.data.errorCode == authResponses.invalidPhone) {
        dispatch(Actions.setPhoneErr(true));
      } else if (err.response?.data.errorCode == authResponses.tooManyRequestsByHour) {
        dispatch(Actions.setIsTempBanned(true, err.response?.data?.banUntilTime))
      }
    });
  },
  signIn: ({ phone, countryCode, oneTimePassword, pinCode }: signInProps) => (
    dispatch: Dispatch
  ): void => {
    dispatch(Actions.setPassword(oneTimePassword));
    authApi
      .signIn({ phone, countryCode, oneTimePassword, pinCode })
      .then((resp) => {
        if (resp.status == 200) {
          window.localStorage.accessToken = resp.data.accessToken;
          window.localStorage.refreshToken = resp.data.refreshToken;
          window.localStorage.idProfile = resp.data.idProfile;
          window.localStorage.tokenTime = new Date().toISOString();
          dispatch(Actions.setIsAuth(true));
          //@ts-ignore
          dispatch(profileActions.getExtendedProfileInfo());
        }
      })
      .catch((err) => {
        if (
          err.response?.data.errorCode == authResponses.wrongOneTimePassword ||
          err.response?.data.errorCode ==
            authResponses.invalidFormatOneTimePassword
        ) {
          dispatch(Actions.setPasswordErr({ errStatus: true }));
        } else if (err.response?.data.errorCode == authResponses.userBanned) {
          dispatch(Actions.setSystemBan(true, err.response.data.reason)); //
        } else if (
          err.response?.data.errorCode == authResponses.profileDeleted
        ) {
          dispatch(Actions.setProfileDeleted(true));
        } else if (
          err.response?.data.errorCode == authResponses.userIsNotRegistred
        ) {
          dispatch(Actions.setSignUp(true));
        } else if (
          err.response?.data.errorCode == authResponses.pinCodeIsNeed
        ) {
          dispatch(Actions.setIsPinCodeNeed(true));
        } else if (
          err.response?.data.errorCode == authResponses.invalidPinCode ||
          err.response?.data.errorCode == authResponses.wrongPinCode
        ) {
          dispatch(Actions.setPinCodeErr(true)); //TODO добавить оставшиеся попытки; upd: спустя ровно год, они мне так и не приходят с бекенда
        } //TODO else
      });
  },
  signUp: ({
    phone,
    countryCode,
    oneTimePassword,
    name,
    sex,
    interestedGender,
    birthday,
    cityId,
  }: signUpProps) => (dispatch: Dispatch): void => {
    dispatch(Actions.setIsFilling(true));
    authApi
      .signUp({
        phone,
        countryCode,
        oneTimePassword,
        name,
        //@ts-ignore
        sex: genderEnum[sex],
        //@ts-ignore
        interestedGender: genderEnum[interestedGender],
        birthday,
        cityId,
      })
      .then((resp) => {
        if (resp.status == 200) {
          window.localStorage.accessToken = resp.data.accessToken;
          window.localStorage.refreshToken = resp.data.refreshToken;
          window.localStorage.idProfile = resp.data.idProfile;
          window.localStorage.tokenTime = new Date().toISOString();
          dispatch(Actions.setIsAuth(true));
          //@ts-ignore
          dispatch(profileActions.getProfileInfo());
        }
      })
      .catch((err) => {
        alert(err.response?.data.errorMessage);
        dispatch(Actions.setIsFilling(false));
      });
  },
  setPincode: (pincode: string) => (dispatch: Dispatch) => [
    authApi.setPincode(pincode).catch((err) => {
      if (
        err.response?.data.errorCode === authResponses.settedPincodeIncorrect
      ) {
        alert("Некорректный пинкод");
      } else if (
        err.response?.data.errorCode ===
        authResponses.settedPincodeAlreadyExists
      ) {
        alert("Уже задан другой пинкод");
      } else {
        alert(err.response?.data?.errorMessage);
      }
    }),
  ],
  signOut: (deviceId?: number) => (dispatch: Dispatch) => {
    console.log('signOut action called, deviceId:', deviceId);
    console.log('Making API call to signOut...');
    authApi
      .signOut(deviceId)
      .then((resp) => {
        console.log('signOut API success:', resp);
        dispatch(Actions.setIsAuth(false));
        dispatch(Actions.setFbToken(''));
        dispatch(Actions.setGoogleCode(''));
        delete window.localStorage.refreshToken;
        delete window.localStorage.accessToken;
        delete window.localStorage.idProfile;
        window.location.reload()
      })
      .catch((err) => {
        console.error('signOut API error:', err);
        console.log('Clearing auth state anyway...');
        dispatch(Actions.setIsAuth(false));
        dispatch(Actions.setFbToken(''));
        dispatch(Actions.setGoogleCode(''));
        delete window.localStorage.refreshToken;
        delete window.localStorage.accessToken;
        delete window.localStorage.idProfile;
        console.log('Cleared localStorage, reloading page...');
        window.location.reload()
      });
  },
  getCountriesList: () => (dispatch: Dispatch) => {
    const lang = (window.localStorage.getItem("i18nextLng") || "en").split("-")[0];
    // Локализованный гео-эндпоинт (страны+города+флаги), как в приложении.
    authApi
      .getGeo(lang)
      .then((resp) => {
        const raw: Array<any> = (resp.data && resp.data.countries) || [];
        const countries: Array<{ id: any; name: string }> = [];
        const citiesByCountry: Record<string, Array<{ id: any; name: string }>> = {};
        raw.forEach((c: any) => {
          const id = c?.id != null ? c.id : c?.countryId;
          if (id == null) return;
          const name = c?.name || "";
          const flag = c?.flag || "";
          countries.push({ id, name: flag ? `${flag}  ${name}` : name });
          citiesByCountry[id] = (c?.cities || [])
            .map((city: any) => ({ id: city?.id != null ? city.id : city?.cityId, name: city?.name || "" }))
            .filter((city: any) => city.id != null);
        });
        if (!countries.length) throw new Error("empty geo");
        geoCitiesByCountry = citiesByCountry;
        try { window.localStorage.geoCitiesByCountry = JSON.stringify(citiesByCountry); } catch (e) {}
        dispatch(Actions.setCountriesList(countries));
        window.localStorage.countriesList = JSON.stringify(countries);
        delete window.localStorage.citiesList;
      })
      .catch(() => {
        // Фоллбэк на старый эндпоинт (английский), чтобы список не пропал.
        authApi.getCountries().then((resp) => {
          dispatch(Actions.setCountriesList(resp.data.countries));
          window.localStorage.countriesList = JSON.stringify(resp.data.countries);
          delete window.localStorage.citiesList;
        });
      });
  },
  getCitiesList: (countryId: number) => (dispatch: Dispatch) => {
    // Сначала берём локализованные города из гео-кэша; если нет — старый эндпоинт.
    let cache = geoCitiesByCountry;
    if (!cache || !Object.keys(cache).length) {
      try { cache = JSON.parse(window.localStorage.geoCitiesByCountry || "{}"); } catch (e) { cache = {}; }
    }
    const cached = cache && cache[countryId as any];
    if (cached && cached.length) {
      dispatch(Actions.setCitiesList(cached));
      window.localStorage.citiesList = JSON.stringify(cached);
      return;
    }
    authApi.getCities(countryId).then((resp) => {
      dispatch(Actions.setCitiesList(resp.data.cities));
      window.localStorage.citiesList = JSON.stringify(resp.data.cities);
    });
    //.catch((err) => alert(err.response?.data?.errorMessage))
  },
  getSocket: () => (dispatch: Dispatch) => {
    authApi
      .getSocket()
      .then((resp) => {
        dispatch(Actions.setSocket(resp.data.ticket));
      })
      .catch(err => {
        if (err.response?.data?.errorCode === commonErrorResponses.notVerified) {
          dispatch(profileActions.setNotVerified(true));
          dispatch(profileActions.setGender(genderEnumFromApi[err.response.data.sex] || "Female"));
        }
        if (err.response?.data?.errorCode === commonErrorResponses.notHavePhoto) {
          dispatch(profileActions.setNotHavePhoto(true));
          dispatch(profileActions.setGender(genderEnumFromApi[err.response.data.sex] || "Female"));
        }
        if (err.response?.data?.errorCode === commonErrorResponses.photoWasDeleted) {
          dispatch(profileActions.setNotHavePhoto(true));
          dispatch(profileActions.setReasonDeletingPhoto(err.response.data.reason))
          dispatch(profileActions.setGender(genderEnumFromApi[err.response.data.sex] || "Female"));
        }
        if (err.response?.data?.errorCode === commonErrorResponses.verifyWasDeleted) {
          dispatch(profileActions.setNotVerified(true));
          dispatch(profileActions.setGender(genderEnumFromApi[err.response.data.sex] || "Female"));
        }
      })
  },
  setNeedRefresh: (status: boolean) => ({
    type: actionTypes.SET_NEED_REFRESH,
    payload: status,
  }),
  setUsedToken: (token: string) => {
    window.localStorage.usedToken = token;
    return {
      type: actionTypes.SET_USED_TOKEN,
      payload: token,
    };
  },
  setFbToken: (token: string) => ({
    type: actionTypes.SET_FB_TOKEN,
    payload: token,
  }),
  setGoogleCode: (code: string) => ({
    type: actionTypes.SET_GOOGLE_CODE,
    payload: code,
  }),
  setIsSigningUpByFb: (status: boolean) => ({
    type: actionTypes.SET_IS_SIGNING_UP_BY_FB,
    payload: status,
  }),
  setIsSigningUpByGoogle: (status: boolean) => ({
    type: actionTypes.SET_IS_SIGNING_UP_BY_GOOGLE,
    payload: status,
  }),
  fbSignIn: (token: string) => (dispatch: Dispatch) => {
    authApi.fbSignIn(token)
    .then(resp => {
      if (resp.status == 200 && !resp.data.confirmationToken) {
        window.localStorage.accessToken = resp.data.accessToken;
        window.localStorage.refreshToken = resp.data.refreshToken;
        window.localStorage.idProfile = resp.data.idProfile;
        window.localStorage.tokenTime = new Date().toISOString();
        dispatch(Actions.setIsAuth(true));
        //@ts-ignore
        dispatch(profileActions.getExtendedProfileInfo());
        dispatch(Actions.setFbToken(""))
      } else if (resp.data.confirmationToken) {
          dispatch(Actions.setSignUp(true));
          dispatch(Actions.setIsSigningUpByGoogle(true));
          dispatch(Actions.setConfirmationToken(resp.data.confirmationToken))
          dispatch(Actions.setFbToken(""))
        }
    })
    .catch((err) => {
      if (err.response?.data.errorCode == authResponses.userBanned) {
        dispatch(Actions.setSystemBan(true, err.response.data.reason)); //
      } else if (
        err.response?.data.errorCode == authResponses.profileDeleted
      ) {
        dispatch(Actions.setProfileDeleted(true));
      } else if (
        err.response?.data.errorCode == authResponses.userIsNotRegistred
      ) {
        dispatch(Actions.setSignUp(true));
        dispatch(Actions.setIsSigningUpByFb(true))
        dispatch(Actions.setConfirmationToken(err.response.data.confirmToken))
      } 
    });
  },
  fbSignUp: (token: string, {
    phone,
    countryCode,
    oneTimePassword,
    name,
    sex,
    interestedGender,
    birthday,
    cityId,
  }: signUpProps) => (dispatch: Dispatch): void => {
    dispatch(Actions.setIsFilling(true));
    authApi
    .fbSignUp(token, {
      phone,
      countryCode,
      oneTimePassword,
      name,
      //@ts-ignore
      sex: genderEnum[sex],
      //@ts-ignore
      interestedGender: genderEnum[interestedGender],
      birthday,
      cityId,
    })
    .then((resp) => {
      if (resp.status == 200) {
        window.localStorage.accessToken = resp.data.accessToken;
        window.localStorage.refreshToken = resp.data.refreshToken;
        window.localStorage.idProfile = resp.data.idProfile;
        window.localStorage.tokenTime = new Date().toISOString();
        dispatch(Actions.setIsAuth(true));
        //@ts-ignore
        dispatch(profileActions.getProfileInfo());
        dispatch(Actions.setIsSigningUpByFb(false));
        dispatch(Actions.setFbToken(""))
      }
    })
    .catch((err) => {
      alert(err.response?.data.errorMessage);
      dispatch(Actions.setIsFilling(false));
      dispatch(Actions.setFbToken(""))
    });
  },
  googleSignIn: (code: string) => (dispatch: Dispatch) => {
    console.log('googleSignIn called with code:', code);
    authApi.googleSignIn(code)
    .then((resp) => {
        console.log('googleSignIn response status:', resp.status);
        console.log('googleSignIn response headers:', resp.headers);
        console.log('googleSignIn response data type:', typeof resp.data);
        console.log('googleSignIn response data (first 200 chars):', 
          typeof resp.data === 'string' ? resp.data : resp.data);
        
        // Проверяем, что ответ - это JSON, а не HTML
        if (typeof resp.data === 'string' && resp.data.trim().startsWith('<!')) {
          console.error('API returned HTML instead of JSON. Response:', resp.data.substring(0, 500));
          alert('Ошибка: сервер вернул HTML вместо JSON. Проверьте настройки API.');
          return;
        }
        
        // Проверяем, что это объект
        if (typeof resp.data !== 'object' || resp.data === null) {
          console.error('API returned non-object response:', resp.data);
          alert('Ошибка: неверный формат ответа от сервера');
          return;
        }
      console.log('googleSignIn response:', resp.data);
      if (resp.status == 200 && !resp.data.confirmationToken) {
        console.log('Existing user, setting isAuth=true');
        window.localStorage.accessToken = resp.data.accessToken;
        window.localStorage.refreshToken = resp.data.refreshToken;
        window.localStorage.idProfile = resp.data.idProfile;
        window.localStorage.tokenTime = new Date().toISOString();
        dispatch(Actions.setIsAuth(true));
        dispatch(Actions.setIsSigningUpByGoogle(false));
        //@ts-ignore
        dispatch(profileActions.getExtendedProfileInfo());
        dispatch(Actions.setGoogleCode(""))
        console.log('After dispatch, isAuth should be true');
      } else if (resp.data.confirmationToken) {
        console.log('New user, setting isSigningUpByGoogle=true');
        dispatch(Actions.setSignUp(true));
        dispatch(Actions.setIsSigningUpByGoogle(true));
        dispatch(Actions.setGoogleCode(""))
        dispatch(Actions.setConfirmationToken(resp.data.confirmationToken))
      }
    })
    .catch((err) => {
        console.error('googleSignIn error:', err);
        console.error('Error response:', err.response);
        console.error('Error response data:', err.response?.data);
        
        // Если ошибка - это HTML, выводим более понятное сообщение
        if (err.response?.data && typeof err.response.data === 'string' && err.response.data.trim().startsWith('<!')) {
          console.error('Server returned HTML error page');
          alert('Ошибка: сервер вернул HTML страницу. Возможно, endpoint неправильный или сервер недоступен.');
          return;
        }

        if (err.response?.status === 304) {
            dispatch(Actions.setIsSigningUpByGoogle(false));
            alert('Ответ был закэширован. Попробуйте войти через Google ещё раз.');
            return;
          }
                
      if (err.response?.data.errorCode == authResponses.userBanned) {
        dispatch(Actions.setSystemBan(true, err.response.data.reason)); //
      } else if (
        err.response?.data.errorCode == authResponses.profileDeleted
      ) {
        dispatch(Actions.setProfileDeleted(true));
      } else if (
        err.response?.data.errorCode == authResponses.userIsNotRegistred
      ) {
        dispatch(Actions.setSignUp(true));
        dispatch(Actions.setIsSigningUpByGoogle(true));
        dispatch(Actions.setConfirmationToken(err.response.data.confirmToken))
      } else {
        // Добавьте сброс isSigningUpByGoogle при других ошибках
        dispatch(Actions.setIsSigningUpByGoogle(false));
      }
    });
  },
  appleSignIn: (code: string, identityToken?: string, redirectUri?: string) => (dispatch: Dispatch) => {
    authApi.appleSignIn(code, identityToken, redirectUri)
    .then((resp) => {
      if (resp.status == 200 && !resp.data.confirmationToken) {
        window.localStorage.accessToken = resp.data.accessToken;
        window.localStorage.refreshToken = resp.data.refreshToken;
        window.localStorage.idProfile = resp.data.idProfile;
        window.localStorage.tokenTime = new Date().toISOString();
        dispatch(Actions.setIsAuth(true));
        //@ts-ignore
        dispatch(profileActions.getExtendedProfileInfo());
      } else if (resp.data.confirmationToken) {
        dispatch(Actions.setSignUp(true));
        dispatch(Actions.setIsSigningUpByGoogle(true));
        dispatch(Actions.setConfirmationToken(resp.data.confirmationToken));
      }
    })
    .catch((err) => {
      if (err.response?.data.errorCode == authResponses.userBanned) {
        dispatch(Actions.setSystemBan(true, err.response.data.reason));
      } else if (
        err.response?.data.errorCode == authResponses.profileDeleted
      ) {
        dispatch(Actions.setProfileDeleted(true));
      } else if (
        err.response?.data.errorCode == authResponses.userIsNotRegistred
      ) {
        dispatch(Actions.setSignUp(true));
        dispatch(Actions.setIsSigningUpByGoogle(true));
        dispatch(Actions.setConfirmationToken(err.response.data.confirmToken));
      } else {
        alert(err.response?.data?.errorMessage || "Ошибка авторизации через Apple");
      }
    });
  },
  googleSignUp: (code: string, {
    phone,
    countryCode,
    oneTimePassword,
    name,
    sex,
    interestedGender,
    birthday,
    cityId,
  }: signUpProps) => (dispatch: Dispatch): void => {
    dispatch(Actions.setIsFilling(true));
    authApi
      .googleSignUp(code, {
        phone,
        countryCode,
        oneTimePassword,
        name,
        //@ts-ignore
        sex: genderEnum[sex],
        //@ts-ignore
        interestedGender: genderEnum[interestedGender],
        birthday,
        cityId,
      })
      .then((resp) => {
        if (resp.status == 200) {
          window.localStorage.accessToken = resp.data.accessToken;
          window.localStorage.refreshToken = resp.data.refreshToken;
          window.localStorage.idProfile = resp.data.idProfile;
          window.localStorage.tokenTime = new Date().toISOString();
          dispatch(Actions.setIsAuth(true));
          //@ts-ignore
          dispatch(profileActions.getProfileInfo());
          dispatch(Actions.setIsSigningUpByGoogle(false));
          dispatch(Actions.setGoogleCode(""))
        }
      })
      .catch((err) => {
        alert(err.response?.data.errorMessage);
        dispatch(Actions.setIsFilling(false));
        dispatch(Actions.setGoogleCode(""))
      });
  },
  setConfirmationToken: (token: string) => ({
    type: actionTypes.SET_CONFIRMATION_TOKEN,
    payload: token
  }),
  setIsOpenModalPhone: (status: boolean) => ({
    type: actionTypes.SET_IS_OPEN_MODAL_PHONE,
    payload: status
  }),
};


export default Actions;
